import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import Pagination from "./Pagination";
import SearchTextField from "../../../../components/SearchTextField";

interface OrganizationSelectionProps {
  organizations: Organization[];
  setSelectedOrganization: (organization: Organization | null) => void;
}

const OrganizationSelection: React.FC<OrganizationSelectionProps> = ({
  organizations,
  setSelectedOrganization,
}) => {
  const { t } = useTranslation();
  const [dataOrganizations, setOrganizations] =
    useState<Organization[]>(organizations);
  const [page, setPage] = useState(0);
  const itemsPerPage = 12;

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    const filtered = organizations.filter((o) =>
      o.name.toLowerCase().includes(searchTerm),
    );
    setOrganizations(filtered);
  };

  return (
    <>
      <SearchTextField
        handleSearch={handleSearch}
        placeholder={t("home.searchOrganizationPlaceholder")}
        title={t("home.searchOrganizationTitle")}
      />
      <Box sx={{ width: "100%", padding: "8px" }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            marginBottom: "32px",
          }}
        >
          {dataOrganizations
            .filter((organization) => organization.enabled)
            .slice(page * itemsPerPage, (page + 1) * itemsPerPage)
            .map(({ id, name, enabled }) => (
              <Button
                className="button"
                key={id}
                onClick={() => {
                  setSelectedOrganization({ id, name, enabled });
                }}
                sx={{
                  boxShadow: 1,
                  borderRadius: "12px",
                  width: dataOrganizations.length === 1 ? "100%" : "48%",
                }}
                variant="contained"
              >
                {name}
              </Button>
            ))}
        </Box>
        {dataOrganizations.length === 0 ? (
          <Box sx={{ textAlign: "center" }}>
            <Typography color="textSecondary" variant="body1">
              {t("home.noOrganization")}
            </Typography>
          </Box>
        ) : (
          <Pagination
            itemsPerPage={itemsPerPage}
            page={page}
            setPage={setPage}
            totalItems={organizations.length}
          />
        )}
      </Box>
    </>
  );
};

export default OrganizationSelection;
